var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cal = function (_React$Component) {
    _inherits(Cal, _React$Component);

    function Cal() {
        _classCallCheck(this, Cal);

        return _possibleConstructorReturn(this, (Cal.__proto__ || Object.getPrototypeOf(Cal)).apply(this, arguments));
    }

    _createClass(Cal, [{
        key: "render",
        value: function render() {
            return React.createElement(Calc, null);
        }
    }]);

    return Cal;
}(React.Component);

var Calc = function (_React$Component2) {
    _inherits(Calc, _React$Component2);

    function Calc(props) {
        _classCallCheck(this, Calc);

        var _this2 = _possibleConstructorReturn(this, (Calc.__proto__ || Object.getPrototypeOf(Calc)).call(this, props));

        _this2.ChangePlan = function (event) {
            var sum = void 0,
                sum2 = void 0;
            sum = Number(event.target.value) * Number(_this2.state.val_staff);
            sum2 = 0 * Number(_this2.state.val_staff);
            _this2.setState({
                val_plan: event.target.value,
                val_sum: sum,
                val_sum2: sum2,
                val_total: sum
            });
        };

        _this2.state = {
            val_plan: "500",
            val_staff: "",
            val_staff2: "",
            val_sum: "-",
            val_sum2: "-",
            val_total: "-"
        };
        _this2.ChangePlan = _this2.ChangePlan.bind(_this2);
        _this2.ChangeNumber = _this2.ChangeNumber.bind(_this2);
        _this2.ChangeNumberZero = _this2.ChangeNumberZero.bind(_this2);
        return _this2;
    }

    _createClass(Calc, [{
        key: "ChangeNumber",
        value: function ChangeNumber(e) {
            var sum = void 0;
            sum = Number(this.state.val_plan) * Number(e.target.value);
            this.setState({
                val_staff: e.target.value,
                val_sum: sum,
                val_total: sum
            });
        }
    }, {
        key: "ChangeNumberZero",
        value: function ChangeNumberZero(e) {
            var sum2 = void 0;
            sum2 = 0 * Number(e.target.value);
            this.setState({
                val_staff2: e.target.value,
                val_sum2: sum2
            });
        }
    }, {
        key: "render",
        value: function render() {
            var _this3 = this;

            return React.createElement(
                "div",
                null,
                React.createElement(
                    "table",
                    { className: "p-pricing-plan__cal" },
                    React.createElement(
                        "tr",
                        null,
                        React.createElement(
                            "th",
                            { className: "p-pricing-plan__cal__heading" },
                            "\u30D7\u30E9\u30F3"
                        ),
                        React.createElement(
                            "td",
                            { className: "p-pricing-plan__cal__desc" },
                            React.createElement("input", { type: "radio", id: "plan-standard", name: "plan", className: "p-pricing-plan__cal__radio", value: "500", checked: this.state.val_plan === "500", onChange: function onChange(e) {
                                    return _this3.ChangePlan(e);
                                } }),
                            React.createElement(
                                "label",
                                { "for": "plan-standard", className: "p-pricing-plan__cal__label -standard" },
                                "\u30B9\u30BF\u30F3\u30C0\u30FC\u30C9\u30D7\u30E9\u30F3(500\u5186/\u6708)"
                            ),
                            React.createElement("input", { type: "radio", id: "plan-higher", name: "plan", className: "p-pricing-plan__cal__radio", value: "600", checked: this.state.val_plan === "600", onChange: function onChange(e) {
                                    return _this3.ChangePlan(e);
                                } }),
                            React.createElement(
                                "label",
                                { "for": "plan-higher", className: "p-pricing-plan__cal__label -higher" },
                                "\u3007\u3007\u30D7\u30E9\u30F3(600\u5186/\u6708)"
                            )
                        )
                    ),
                    React.createElement(
                        "tr",
                        null,
                        React.createElement(
                            "th",
                            { className: "p-pricing-plan__cal__heading" },
                            "\u5229\u7528\u4EBA\u6570"
                        ),
                        React.createElement(
                            "td",
                            { className: "p-pricing-plan__cal__desc" },
                            React.createElement(
                                "dl",
                                { className: "p-pricing-plan__cal__case" },
                                React.createElement(
                                    "dt",
                                    { className: "p-pricing-plan__cal__staff -lot" },
                                    "\u6708\u306B",
                                    React.createElement(
                                        "span",
                                        null,
                                        "5\u65E5\u4EE5\u4E0A"
                                    ),
                                    "\u5229\u7528\u3059\u308B\u30B9\u30BF\u30C3\u30D5",
                                    React.createElement("input", { type: "tel", "class": "control-number", onChange: this.ChangeNumber, value: this.state.val_staff, placeholder: "0" }),
                                    "\u4EBA"
                                ),
                                React.createElement(
                                    "dd",
                                    { className: "p-pricing-plan__cal__price -lot" },
                                    React.createElement(
                                        "span",
                                        null,
                                        this.state.val_sum
                                    ),
                                    "\u5186"
                                )
                            ),
                            React.createElement(
                                "dl",
                                { className: "p-pricing-plan__cal__case" },
                                React.createElement(
                                    "dt",
                                    { className: "p-pricing-plan__cal__staff -little" },
                                    "\u6708\u306B",
                                    React.createElement(
                                        "span",
                                        null,
                                        "4\u65E5\u4EE5\u4E0B"
                                    ),
                                    "\u5229\u7528\u3059\u308B\u30B9\u30BF\u30C3\u30D5",
                                    React.createElement("input", { type: "tel", "class": "control-number", name: "people", onChange: this.ChangeNumberZero, value: this.state.val_staff2, placeholder: "0" }),
                                    "\u4EBA"
                                ),
                                React.createElement(
                                    "dd",
                                    { className: "p-pricing-plan__cal__at" },
                                    React.createElement(
                                        "a",
                                        { href: "#policy", className: "c-link-regular" },
                                        "\u5F53\u6708\u306E\u5229\u7528\u65E5\u6570\u304C\u5C11\u306A\u3044\u30B9\u30BF\u30C3\u30D5\u306F\u8ACB\u6C42\u3055\u308C\u307E\u305B\u3093\u3002"
                                    )
                                ),
                                React.createElement(
                                    "dd",
                                    { className: "p-pricing-plan__cal__price -little" },
                                    React.createElement(
                                        "span",
                                        null,
                                        this.state.val_sum2
                                    ),
                                    "\u5186"
                                )
                            )
                        )
                    )
                ),
                React.createElement(
                    "div",
                    { className: "p-pricing-plan__cal__sum" },
                    React.createElement(
                        "span",
                        { className: "p-pricing-plan__cal__title" },
                        "\u6708\u984D\u5408\u8A08\u8CBB\u7528\uFF08\u7A0E\u629C\uFF09"
                    ),
                    React.createElement(
                        "span",
                        { className: "p-pricing-plan__cal__total" },
                        React.createElement(
                            "span",
                            null,
                            this.state.val_total
                        ),
                        "\u5186"
                    )
                )
            );
        }
    }]);

    return Calc;
}(React.Component);

var havecal = document.getElementById('calculator');
if (havecal !== null) {
    ReactDOM.render(React.createElement(Cal, null), havecal);
}